import React from 'react';

import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { GraySmall } from 'src/theme/colors';

interface FormLabelProps {
  primaryText: string;
  secondaryText?: string;
}
export const FormLabel: React.FC<FormLabelProps> = ({
  primaryText,
  secondaryText,
}) => (
  <div>
    <BaseTypography fontType="13Medium" component="span">
      {primaryText}
    </BaseTypography>
    {secondaryText && (
      <BaseTypography component="span" style={{ color: GraySmall }}>
        {secondaryText}
      </BaseTypography>
    )}
  </div>
);
